<template>
  <ph-window>
    <!--Top header bar here-->
    <tool-bar type="header" id="app_header">
      <div style="clear: both">
        <div @click="toggleMenu()">
          <div v-if="isDaily">
            <h4 style="float: left">&nbsp;&nbsp;&nbsp;Daily System</h4>
          </div>
          <div v-if="isBookkeeping">
            <h4 style="float: left">&nbsp;&nbsp;&nbsp;Bookeeping Reports</h4>
          </div>
        </div>
        <div @click="logout()" style="float: right">
          <h4 >Logout</h4>
        </div>
      </div>
      
    </tool-bar>
    <!--Window content here-->
    <window-content>

      <div class="pane-group">
        
        <div v-if="displayMenu" class="pane-sm sidebar">
          <div v-if="isDaily">
            <Navigation />
          </div>
          <div v-if="isBookkeeping">
            <BookkeepingNavigation />
          </div>
        </div>

        <div class="pane" id="main_pane">
          <router-view class="router-pane" />
        </div>

      </div>
    </window-content>
    <!--Bottom footer bar here-->

    <!-- Just removed the footer for now, as it had no purpose
    <tool-bar type="footer">
      
    </tool-bar> -->
  </ph-window>
</template>

<script>
import Navigation from '@/components/Navigation/Navigation.vue'
import BookkeepingNavigation from '@/components/Navigation/BookkeepingNavigation.vue'

export default {
  name: 'Main',
  data: function () {
      return {
          displayMenu : true,
      }
  }, 
  components: {
		Navigation, BookkeepingNavigation
  },
  methods: {
    logout: function(){
      console.log('Logging out');
      localStorage.removeItem('_auid');
      this.$router.push({path:'/'})
      // this.$router.go(0);
      location.reload();
    },
    toggleMenu: function(){
      console.log('DEBUG MENU', this.displayMenu);
      this.displayMenu = !this.displayMenu
    }
  },
  computed:{
    isBookkeeping(){return this.$isBookkeeping},
    isDaily(){return this.$isDaily},
  },
}
</script>


<style>
  *  {
    -webkit-user-select: auto !important ;  /* Chrome 49+ */
    -moz-user-select: auto !important ;     /* Firefox 43+ */
    -ms-user-select: auto !important ;      /* No support yet */
    user-select: auto !important ;          /* Likely future */   
  }
  @media print {

    
    /* This is sloppy and needs further work
      Printing works in safari, and Chrome
      I can't get the page breaks to work yet
    */
    .pane-sm, #app_header, .dont-print { 
      display: none !important ; 
    }
    
    body, #app, #main_pane, ph-window, window-content, .pane-group {
      height:100vw !important ;
      width: 100vw !important ;
      overflow: visible !important ;
      overflow-y:visible; 
      
    }
    body, #app, #main_pane, ph-window, window-content, .pane-group {
      overflow: visible !important ;
      position: relative !important ;
      flex: none !important ;
      -ms-flex: 0 !important ; /* IE 10 */
      flex: 0 !important ;
      /* width:100% !important ; */
      /* height:100% !important ; */
      /* width: 100vw !important ; 
      height: 100vh !important ;

      page-break-after:always !important ;
      display: inline !important ; */
      left: 0px !important ;
      top: 0px !important ;
      position:absolute !important ;
      /* page-break-after:always !important ; */
       width: auto !important ;
      height: auto !important ;
      overflow: visible !important ;
      display: block !important ;
    }
    
    /* I can't get pagebreaks to work */
    /* .pagebreak { 
      clear: both !important;
      display: block !important;
      page-break-after: always !important;
      break-after: page !important;
    }  */

  }
  
</style>
